/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerBeneficiariesDtoApiResponse } from '../../models/customer-beneficiaries-dto-api-response';

export interface GetCustomerBeneficiaryAsync$Plain$Params {
  beneficiaryId: number;
  id: number;
}

export function getCustomerBeneficiaryAsync$Plain(http: HttpClient, rootUrl: string, params: GetCustomerBeneficiaryAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerBeneficiariesDtoApiResponse>> {
  const rb = new RequestBuilder(rootUrl, getCustomerBeneficiaryAsync$Plain.PATH, 'get');
  if (params) {
    rb.path('beneficiaryId', params.beneficiaryId, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CustomerBeneficiariesDtoApiResponse>;
    })
  );
}

getCustomerBeneficiaryAsync$Plain.PATH = '/api/customer/{id}/beneficiary/{beneficiaryId}';
